var _defs, _circle, _line, _line2, _line3, _animate, _animate2, _animate3, _animate4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 153.63 153.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .x-lines{\r\n        fill:none;\r\n        stroke:#e83a45;\r\n        stroke-linecap:round;\r\n        stroke-linejoin:round;\r\n        stroke-width:12px;\r\n        }\r\n      #base{\r\n        stroke-dasharray: 1000;\r\n        stroke-dashoffset: 1000;\r\n        transform-origin: 50% 50%;\r\n        transform: rotate(-90deg)\r\n      }\r\n      #line{\r\n        stroke-dasharray: 200;\r\n        stroke-dashoffset: 200;\r\n      }\r\n      #line-part-1{\r\n        stroke-dasharray: 200;\r\n        stroke-dashoffset: 200;\r\n      }\r\n      #line-part-2{\r\n        stroke-dasharray: 200;\r\n        stroke-dashoffset: -200;\r\n      }\r\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "base",
    className: "x-lines",
    cx: 76.82,
    cy: 76.82,
    r: 70.82
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "line-part-1",
    className: "x-lines",
    x1: 66.76,
    y1: 66.76,
    x2: 43.09,
    y2: 43.09
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "line-part-2",
    className: "x-lines",
    x1: 110.54,
    y1: 110.54,
    x2: 79.49,
    y2: 79.49
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "line",
    className: "x-lines",
    x1: 43.09,
    y1: 110.54,
    x2: 110.54,
    y2: 43.09
  })), _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    id: "base-anim",
    href: "#base",
    attributeName: "stroke-dashoffset",
    from: -1000,
    to: 0,
    dur: "1s",
    fill: "freeze"
  })), _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    id: "line-anim",
    href: "#line",
    attributeName: "stroke-dashoffset",
    values: "-200; -200; 0",
    keyTimes: "0; 0.50; 1",
    dur: "1.2s",
    fill: "freeze"
  })), _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    id: "part-1-anim",
    href: "#line-part-1",
    attributeName: "stroke-dashoffset",
    values: "-200; -200; 0",
    keyTimes: "0; 0.50; 1",
    dur: "1s",
    fill: "freeze"
  })), _animate4 || (_animate4 = /*#__PURE__*/React.createElement("animate", {
    id: "part-2-anim",
    href: "#line-part-2",
    attributeName: "stroke-dashoffset",
    values: "-200; -200; 0",
    keyTimes: "0; 0.50; 1",
    dur: "1.2s",
    fill: "freeze"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.f11a6d5b3f6c8123e6bc7b61c8c9b218.svg";
export { ForwardRef as ReactComponent };